import { retrievedAppState } from '../redux/slices/App.slice';
import { store } from '../redux/store';
import Authentication from '../Services/Authentication.service';
import { IExtensionCommand } from '../Types/command.types';

export const startTwitchListeners = () => {
	const twitch = globalThis.Twitch ? globalThis.Twitch.ext : null;

	if (twitch) {
		twitch.listen('broadcast', (target, contentType, body) => {
			let parsedBody = body;
			try {
				parsedBody = JSON.parse(body);
			} catch (err) {
				return;
			}

			if (parsedBody && parsedBody.method) {
				switch (parsedBody.method) {
					// We aren't using this at this time since there's a limit to how big a pubsub payload cna be
					case 'settings-update': {
						store.dispatch(retrievedAppState(parsedBody.payload));
						break;
					}
					case 'online':
					case 'settings-refresh': {
						// Get Config
						Authentication.makeCall('api/extension/config')
							.then((configRes) => {
								const data: IExtensionCommand = configRes.data;
								store.dispatch(retrievedAppState(data));
							})
							.catch((err) => {
								console.error('Error getting configuration: ', err);
							});
						break;
					}
					case 'offline': {
						// TODO: Navigate to offline page
						break;
					}
					case 'cooldown-update': {
						// store.dispatch(retrievedAppState(parsedBody.payload));
						break;
					}
				}
			}
		});

		twitch.onVisibilityChanged((isVisible, _c) => {
			visibilityChanged(isVisible);
		});

		twitch.onContext((context, delta) => {
			contextUpdate(context, delta);
		});
	}
};
export const removeTwitchListeners = () => {
	const twitch = globalThis.Twitch ? globalThis.Twitch.ext : null;

	if (twitch) {
		twitch.unlisten('broadcast', () => null);
	}
};

function visibilityChanged(isVisible?: boolean) {
	return null;
}
function contextUpdate(context, delta) {
	return null;
}
